<template>
  <div class="container text-center my-4">
    <h2>Ingresa tu Email</h2>
    <input v-model="email" type="email" class="form-control my-3" placeholder="Email" />
    <button class="btn btn-primary" @click="validateEmail">Continuar</button>
    <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      errorMessage: '',
    };
  },
  methods: {
    validateEmail() {
      const emailRegex = /^[\w.!#$%&'*+/=?^`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(this.email)) {
        this.$router.push({ path: '/otp', query: { email: this.email } });
      } else {
        this.errorMessage = 'Por favor, ingresa un email válido';
      }
    },
  },
};
</script>
